import {
  FaUser,
  FaUniversity,
  FaShieldAlt,
  FaLifeRing,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const AccountSettings = () => {
  const navigate = useNavigate();
  return (
    <div className="card account-settings">
      <h3>Account Settings</h3>
      <p className="subtitle">
        Manage your profile and account preferences
      </p>

      <div className="settings-grid">
        <SettingItem
          icon={<FaUser />}
          title="Personal Information"
          desc="Update your KYC details, contact information, and profile settings"
          onClick={() => navigate("/profile/personal-info")}
        />

        <SettingItem
          icon={<FaUniversity />}
          title="Bank Accounts"
          desc="Configure payout destinations and manage banking details"
          onClick={() => navigate("/profile/bank-details")}
        />

        <SettingItem
          icon={<FaShieldAlt />}
          title="Security Settings"
          desc="Update password, enable 2FA, and review security options"
        />

        <SettingItem
          icon={<FaLifeRing />}
          title="Support Center"
          desc="Access help documentation and contact support team"
        />
      </div>
    </div>
  );
};

const SettingItem = ({ icon, title, desc,onClick  }) => (
  <div className="setting-item" onClick={onClick}>
    <div className="icon">{icon}</div>
    <div>
      <h4>{title}</h4>
      <p>{desc}</p>
      <span className="manage">Manage →</span>
    </div>
  </div>
);

export default AccountSettings;
